module.exports = __webpack_public_path__ + "img/studywayIcon2.b9476918.png";